import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import './HeaderProfile.css';

const HeaderProfile = () => {
    const { userProfile, currentUser } = useAuth();
    const navigate = useNavigate();

    const getInitials = () => {
        const name = userProfile?.display_name || currentUser?.email || 'User';
        const parts = name.split(/\s+/).filter(p => p.length > 0);
        if (parts.length >= 2) {
            return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
        }
        return name.substring(0, 2).toUpperCase();
    };

    return (
        <div className="header-profile-icon" onClick={() => navigate('/profile')}>
            {getInitials()}
        </div>
    );
};

export default HeaderProfile;
